module.exports = __webpack_public_path__ + "assets/img/menu_bg_1.498319f6.png";